import {
  mdiAccountGroup,
  mdiLightbulbGroup,
  mdiMapMarkerRadius,
  mdiShieldAccount,
  // mdiSchool,
  mdiAccountStar,
  mdiLogout,
  mdiRadio,
  mdiLock,
} from '@mdi/js';

export default {
  computed: {
    isPreview() {
      return window.location.hostname.includes('preview') || window.location.hostname === 'localhost';
    },
    menuItems() {
      return [
        { name: 'menu.membership', pathName: 'membership-MembershipHome', icon: mdiAccountGroup },
        { name: 'menu.radio', pathName: 'Radio', icon: mdiRadio },
        { name: 'menu.readiness', pathName: 'membership-Readiness', icon: mdiLightbulbGroup },
        { name: 'menu.location', pathName: 'membership-EditMyLocation', icon: mdiMapMarkerRadius },
        { name: 'menu.incidents', pathName: 'membership-Incidents', icon: mdiShieldAccount },
        // { name: 'menu.college', pathName: 'membership-College', icon: mdiSchool },
        { name: 'menu.contactLeader', pathName: 'membership-Leader', icon: mdiAccountStar },
        { name: 'menu.password', pathName: 'auth-ChangePassword', icon: mdiLock },
        { name: 'menu.logoff', pathName: 'auth-Logoff', icon: mdiLogout },
      ];
    },
  },
};
